module.exports = __webpack_public_path__ + "static/media/Local.9740346f.svg";